import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { ApplicationSetting } from '../../models/system-setting/application-setting';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()

export class ApplicationSettingsService {
  private service = "api/ApplicationSettings"; //Controller Name
  public systemSettingList: ApplicationSetting[];

  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddSystemSetting(createSettingModel: ApplicationSetting): void {
    this.http
      .post(`${this.service}`, createSettingModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/application-settings"]);
      });
  }
  UpdateSystemSetting(EditSettingModel: ApplicationSetting): void {
    this.http
      .put(`${this.service}`, EditSettingModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/application-settings"]);
      });
  }
  GetSystemSettings() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetSystemSettingsById(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <ApplicationSetting>response.json())
      .catch(this.errorHandler)
  }

  DeleteSystemSetting(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/system-settings/application-setting.ts